import  "./tablestyle.scss";
import {
  Grid,
  GridCellProps,
  GridNoRecords,
  GridColumn as Column
} from "@progress/kendo-react-grid";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";
import { useState } from "react";
import PopupMenu from "../../components/popupmenu";
import AddAwards from "../../modal/addAwards";

const AwardsCertifications = (props: any) => {
  
  const [edit, setEdit] = useState<boolean>(false)
  const [id, setId] = useState<string>('')
  const [data , setData] = useState<any>()

  
  const deleteAwards = (data: any) => {  
    if(data.certificationName){
      let body = {
        "action": "delete",
        "section": "certification",
        "customerId": props.customerId,
        "customerMetadata": {
          "certifications": [
            {
              "certificationId": data.certificationId,
              "certificationNumber": data.certificationNumber,
              "certificationName": data.certificationName,
              "logo": data.logo !== undefined ? data.logo : " ",
              "supportingDoc": data.supportingDocument !== undefined ? data.supportingDocument : " "
            }
          ]
        }
      }
      props.updateAwardCertifications(body)
    }
    if(data.awardName){
      let body = {
        "action": "delete",
        "section": "award",
        "customerId": props.customerId,
        "customerMetadata": {
          "awards": [
            {
              "awardId": data.awardId,
              "awardNumber": data.awardNumber,
              "awardName": data.awardName,
              "logo": data.logo !== undefined ? data.logo : " ",
              "supportingDoc": data.supportingDocument !== undefined ? data.supportingDocument : " "
            }
          ]
        }
      }
      props.updateAwardCertifications(body)
    }
  }

  const updateAwards = (data: any) => {
    if(data.certificationName){
      let body = {
        "action": "update",
        "section": "certification",
        "customerId": props.customerId,
        "customerMetadata": {
          "certifications": [
            {
              "certificationId": id,
              "certificationNumber": data.number,
              "certificationName": data.name,
              "logo": data.logo !== undefined ? data.logo : " ",
              "supportingDoc": data.supportingDocument !== undefined ? data.supportingDocument : " "
            }
          ]
        }
      }
      props.updateAwardCertifications(body)
      setEdit(false)
    }
    if(data.awardName){
      let body = {
        "action": "update",
        "section": "award",
        "customerId": props.customerId,
        "customerMetadata": {
          "awards": [
            {
              "awardId": id,
              "awardNumber": data.number,
              "awardName": data.name,
              "logo": data.logo !== undefined ? data.logo : " ",
              "supportingDoc": data.supportingDocument !== undefined ? data.supportingDocument : " "
            }
          ]
        }
      }
      props.updateAwardCertifications(body)
      setEdit(false)
    }
  }

  const editUser = (type: string, data: any) => {
    if (type === 'edit') { 
      setId(data.awardId ? data.awardId : data.certificationId)
      setData(data)
      setEdit(true)
    }
    else {
      setId(data.awardId ? data.awardId : data.certificationId)
      setData(data)
      deleteAwards(data)
    }
  }

  const editCell = (data: GridCellProps) => { 
    return (
      <td>
        <PopupMenu>
          <div className="popupLinks">
            <Link to="" onClick={() => editUser('edit',data.dataItem)}>
              <Icon icon="lucide:edit-2" />
              Edit
            </Link>
            <Link to="" onClick={() => editUser('delete', data.dataItem)}>
            <Icon icon="icon-park-outline:delete" />
              Delete
            </Link>
          </div>
        </PopupMenu>
      </td>
    )
  }

  const awardCell = (data: GridCellProps) => { 
    return (
      <td>
        {data.dataItem.certificationName ? data.dataItem.certificationName : data.dataItem.awardName}
      </td>
    )
  }

  const numberCell = (data: GridCellProps) => {
    return (
      <td>
        {data.dataItem.certificationNumber ? data.dataItem.certificationNumber : data.dataItem.awardNumber}
      </td>
    )
  }


  const documentCell  = (data: GridCellProps) => {
    return (
      <td className="break-all">
        {data.dataItem.supportingDoc}
      </td>
    )
  }
  
  return (
    <div>
        <Grid data={props.data}>
          <GridNoRecords>
            <div className="noData">
              <Icon icon="mdi:smiley-neutral-outline" />
              No data to display
            </div>
          </GridNoRecords>
            <Column field="award" title="Certificate/Award" cell={awardCell}/>
            <Column field="number" title="Number" cell={numberCell} />
            {/* <Column field="logo" title="Logo" cell={(props: GridCellProps) => logoCell(props, (data: any) => downloadHandle(props))}  /> */}
            <Column field="document" title="Supporting Document" cell={documentCell} />
            <Column cell={editCell}  width="40px"/>
        </Grid>
        {edit && <AddAwards onClose={() => setEdit(false)} clickHandler={updateAwards} defaultValues={data}/>}
    </div>  
  )
}

export default AwardsCertifications;

